import { Action, Types } from '.';

export const Actions = {
  saveChanges: (): Action => ({
    type: Types.SAVE_CHANGES,
  }),
  saveChangesAndRedirect: (siteId: string): Action => ({
    type: Types.SAVE_CHANGES,
    payload: { siteId },
  }),
  discardChanges: (): Action => ({
    type: Types.DISCARD_CHANGES,
  }),
  markForDeletion: (rulesetId: string): Action => ({
    type: Types.DELETE_RULESET,
    payload: { rulesetId },
  }),
  clearRuleset: (): Action => ({
    type: Types.CLEAR_RULESET,
  }),
};
